import { ReactNode } from 'react';
import classNames from 'classnames/bind';
import styles from './ActivityPanel.module.css';

interface PanelContainerProps {
  children: ReactNode;
  isOpen: boolean;
}

export default function PanelContainer({
  children,
  isOpen,
}: PanelContainerProps) {
  const cx = classNames.bind(styles);

  return (
    <div className={cx('widget_container', { open: isOpen })}>{children}</div>
  );
}
